/**
 * 기타 상품코드
 */
export const EtcProductCode = 'P10000';

/** 상품 - 종목 */
export const productCategories: { [key: string]: string } = {
  custom: '맞춤상품',
  vegetable: '채소',
  fruit: '과일',
  grain: '쌀/곡물류',
  livestock: '축산/계란',
  processed: '가공식품',
  marine: '수산/건어물',
  grocery: '잡화',
  preCutVegetable: '전처리채소',
  unknown: '없음',
};

/** 상품 - 종목(Kr to En) */
export const productCategoriesForKr: { [key: string]: string } = {
  맞춤상품: 'custom',
  채소: 'vegetable',
  과일: 'fruit',
  '쌀/곡물류': 'grain',
  '축산/계란': 'livestock',
  가공식품: 'processed',
  '수산/건어물': 'marine',
  잡화: 'grocery',
  전처리채소: 'preCutVegetable',
  없음: 'unknown',
};

export type ProductCategory = keyof typeof productCategories;

/** 상품 - 판매 상태 */
export const productStates = {
  stock: '🟢 재고있음',
  'out-of-stock': '🟡 재고없음',
  discontinued: '🔴 판매중지',
};

export type ProductState = keyof typeof productStates;

/** 상품 - 물품 보관 정보 */
export const productStorages: Record<string, string> = {
  room: '실온',
  refrigerator: '냉장',
  freezer: '냉동',
};

export type ProductStorage = keyof typeof productStorages;

/** 상품 - 패킹 정보 */
export const productPackings: Record<string, string> = {
  bag: '🧺 소분',
  box: '📦 박스',
  others: '기타',
};

export type ProductPacking = keyof typeof productPackings;

export const rawProductStorageToCode: Record<string, ProductStorage> = {
  '1실온': 'room',
  '2냉장': 'refrigerator',
  '3냉동': 'freezer',
};

export const rawProductPackingToCode: Record<string, ProductPacking> = {
  '1소분': 'bag',
  '2박스': 'box',
  '3기타': 'others',
};

export const PRODUCT_MAX_STOCK = Infinity;

export const FEATURES_WITH_PRIORITY = ['박스', '냉동', '냉장'];

export const productTableTooltipMap: Record<string, string> = {
  hidden: '블라인드 상품을 만드는데 사용합니다. true인 경우 미노출되며, 즐겨찾기로 등록한 사용자만 볼 수 있습니다.',
  state: '재고있음: 기본값(구매가능), 재고없음: 품절로 노출됨(구매불가), 판매중지: 노출 안됨(구매불가)',
};

export const productInventoryTableTooltipMap: Record<string, string> = {
  uomEaRatio: '개별 재고 단위 변환 비율: 입고시 재고 수량에 반영하는 비율',
  uomBundleRatio:
    '묶음 재고 단위 변환 비율: 입고시 재고 수량에 반영하는 비율(ex. 8 -> 1개 입고시 재고수량에 1*8을 반영합니다.',
};

export const purchaseConfigTooltipMap: Record<string, string> = {
  purchaseProductName:
    '발주 품명 (예: 굿송이 3번)\n새송이버섯(상급/박스/2kg/국내산)인 상품을 굿송이 3번으로 발주하는 경우',
  purchaseBundle: `발주시 분할 단위를 어떻게 계산할 것인지 정합니다.
- all: 전체 주문량으로 발주
- store: 매장별 주문량으로 발주
- max: 발주 가능 최대 묶음으로 계산해서 발주
- store-group: 매장별 주문량으로 발주하되 같은 수량끼리 묶어서 표현`,
  purchaseMultiplyUnit: `발주 단위 변환 값 (예시)
- 1000: 1kg 상품을 0.5개 주문한 경우 -> 0.5 * 1000 = 500
- 5: 백오이(5개/국내산) 상품을 2개 주문한 경우 -> 2 * 5 = 10`,
  purchaseMaxBundle: `발주 가능 최대 묶음 (예: 3)
null인 경우 매장별 주문량 또는 전체 주문량으로 발주
예시) 5개 주문 시 => 3x1 + 2x1`,
  purchaseUnit: '발주 단위 (예: 개, kg, g, 박스, 팩, 봉지, 포기, 판, 캔, 병)',
};
